import { useEffect, useState } from "react";

import { getActiveStream, subscribeToStream } from "../camera";

// Subscribes to the MediaStream singleton owned by ../camera.ts. Returns the
// current stream (or null) and re-renders whenever it transitions: grant,
// dispose on Done, revoke via OS toggle. Does NOT call requestCameraStream —
// consumers must rely on Gate.tsx (timed flow) or Practice intro (preview opt-in)
// to open the stream.
export function useActiveStream(): MediaStream | null {
  const [stream, setStream] = useState<MediaStream | null>(() => getActiveStream());
  useEffect(() => subscribeToStream(setStream), []);
  return stream;
}
